module.exports = __webpack_public_path__ + "img/TigerEmpire_EGM.fb24b305.jpg";